import { render } from "./ModalImagesGallery.vue?vue&type=template&id=4b6cc948&ts=true"
import script from "./ModalImagesGallery.vue?vue&type=script&lang=ts"
export * from "./ModalImagesGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__